import React from 'react';
import {KeenIcon} from '@/components';
import {toAbsoluteUrl} from '@/utils';
import {Link} from "react-router-dom";

interface NoCompaniesContentProps {
    onAddNewCompany: () => void; // Ensure the prop is properly defined
}

const NoCompaniesContent: React.FC<NoCompaniesContentProps> = ({onAddNewCompany}) => {
    return (
        <div className="grid lg:grid-cols-3 gap-5 lg:gap-7.5">
            <div className="lg:col-span-3">
                <div className="mb-7.5">
                    <div className="card">
                        <div className="card-body px-10 py-7.5 lg:pr-12.5 flex flex-col justify-start">
                            <div className="flex flex-wrap md:flex-nowrap items-start gap-6 md:gap-10">
                                <div className="flex flex-col gap-3">
                                    <h1 className="text-2xl font-semibold text-gray-900">
                                        Start by setting up your first company!
                                    </h1>
                                    <h2 className="text-1xl font-semibold text-gray-900">
                                        Create your company to unlock the power of smart hiring.
                                    </h2>

                                    <p className="text-sm text-gray-700 leading-5.5">
                                        To get started, create your company – the foundation for managing jobs and
                                        candidates.
                                        Once your company is set up, you’ll be able to add job listings, sort through
                                        candidates, and match the right talent to the right roles.
                                    </p>

                                    <p className="text-sm text-gray-700 leading-5.5">
                                        Adding your company is quick and easy: upload details from a URL, drag and drop
                                        your
                                        file, or simply copy and paste the information. After that, you’ll be ready to
                                        streamline
                                        your hiring process with confidence and efficiency.
                                    </p>

                                    <p className="text-sm text-gray-700 leading-5.5">
                                        Don’t worry – UPFLINX Buddy makes everything simple and intuitive, even if
                                        you’re new to
                                        AI-driven tools.
                                    </p>
                                </div>
                                <img
                                    src={toAbsoluteUrl('/media/images/avatar-high.png')}
                                    className="dark:hidden max-h-[250px]"
                                    alt="Welcome"
                                />
                            </div>
                        </div>
                        <div className="card-footer justify-center">
                            <a onClick={onAddNewCompany} className="btn btn-link" role="button">
                                Set up your first company now!
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export {NoCompaniesContent};
